import * as React from 'react';

function Logo() {
  return (
	<img src="/logo512.png" className="App-logo" alt="logo" />
  );
}

export default Logo;
